/*
 * @Author: zhang lin
 * @Date: 2022-04-07 15:06:18
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-01-11 16:56:06
 * @Description: file content
 */
import { GET_CURRENT, SET_CURRENT, GET_CHECKFN, SET_OPERATE } from '../constant';
import { CurrentStates } from 'root/pages/InstallSupos/types';

const defaultStates: CurrentStates = {
  count: 0,
  operate: '',
};

const page = (state = { ...defaultStates }, action: any) => {
  switch (action.type) {
    case GET_CURRENT: {
      return {
        ...state,
        count: 0,
      };
    }
    case SET_CURRENT: {
      return {
        ...state,
        count: state.count + action.payload,
      };
    }
    case GET_CHECKFN: {
      return {
        ...state,
      };
    }

    case SET_OPERATE: {
      return {
        ...state,
        operate: action.payload,
      };
    }

    default:
      return state;
  }
};

export default page;
